const MICROS_PER_USD = 1_000_000;

export const REFRESH_INTERVAL_MS = 15_000;

export function formatUsd(micros: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(micros / MICROS_PER_USD);
}

export function formatNumber(value: number | null, digits = 1): string {
  if (value === null) return "-";
  return Number.isInteger(value) ? String(value) : value.toFixed(digits);
}

export function formatPercent(ratio: number | null): string {
  return ratio === null ? "-" : `${(ratio * 100).toFixed(1)}%`;
}
